import { Radio, RadioProps } from '@mui/material';
import { radioIconProps } from 'Components/RadioIcons';

export const SimpleRadio = ({ sx, ...props }: RadioProps) => {
  const { icon, checkedIcon } = radioIconProps();
  return (
    <Radio
      icon={icon}
      checkedIcon={checkedIcon}
      sx={{
        padding: 0,
        margin: 0,
        ...sx,
      }}
      {...props}
    />
  );
};
